
import React ,{useEffect, useState} from 'react'
import Cookies from 'universal-cookie';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CopyToClipboardButton from '../CopyToClipboardButton/CopyToClipboardButton';
import ListItem from '@mui/material/ListItem';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
export default function Redis() {

    const cookies = new Cookies();
    const [env, setEnv] = useState('');
    const [service,setService] = useState('');
    const [redisConnection, setRedisConnection] = useState('redis-staging');
    const envsOptions = ['staging', 'prod' , 'rc'];
    const [servicesOptions , setServicesOptions] = useState(['infra']);
    const [redisMap, setRedisMap] = useState({"prod":[],"staging":[],"rc":[]});
    const [envInputValue, setEnvInputValue] = useState('');
    const [serviceInputValue, setServiceInputValue] = useState('');
    const [host, setHost] = useState('');
    const [port, setPort] = useState(6379);
    const [db, setDb] = useState(0);
    const cluster = {"prod": "wstgcluster", "staging": "staging", "rc": "staging"};
    useEffect( () => {

        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "code": cookies.get("code"),
          
        })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/get_redis_map" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        setRedisMap(data);
      }
      catch (error){
      }
  
     });
  
     
    },[])
    useEffect(() => {
      if (redisMap[env]) {
          const services = Object.keys(redisMap[env]);
          setServicesOptions(services);
      } else {
          setServicesOptions([]);
      }
    }, [env, redisMap]);
    
    useEffect(() => {

      if (service && redisMap[env] && redisMap[env][service]) {
        const regex = /redis:\/\/([a-zA-Z0-9.\-]+)(:(\d+))?(\/(\d+))?/;
        const host = redisMap[env][service]["host"];
        const matches = host.match(regex);
        if (matches) {
          console.log(matches)
          setHost(matches[1]);
          setPort(matches[3] || 6379);
          setDb(matches[5] || 0);
        }
        else{
          setHost(undefined);
          setPort(undefined);
          setDb(undefined);
        
        }
        if(env == "prod"){
          setRedisConnection("redis-prod");
        }
        else{
          setRedisConnection("redis-staging");
        }
      }
    }, [service, env, redisMap]);

    const update_redis = () => {
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "google_code": cookies.get("google_code"),
        
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/update_redis_services" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          setRedisMap(data);
        }
        catch (error){
        }

      });
    }

  return (
    <div className="split right">
        <div className="box" style={{"background": "white" , "display" : "block" , "height": "max-content" , "padding-left": "2em" , "padding-bottom": "2em" , "font-size": "medium"}}>
          <div style={{"display": "ruby"}}>
        <div className='update'>
        <Tooltip title="Update services" followCursor>
            <UpdateIcon onClick={() =>update_redis()} style={{ cursor: "pointer"}}/>
            </Tooltip>
            </div>
          <h2>Redis cli</h2>
          </div>
          <div>
          Select env:
          </div>
          <Autocomplete
            size="small"
            value={env}
            onChange={(event, newValue) => {
            setEnv(newValue);
            if(newValue == "prod"){
              setRedisConnection("redis-prod");
            }
            }}
            inputValue={envInputValue}
            onInputChange={(event, newInputValue) => {
            setEnvInputValue(newInputValue);
            }}
            id="controllable-states-demo"
            options={envsOptions}
            sx={{ width: 350 , margin : "1em"}}
            renderInput={(params) => <TextField {...params} label="env" />}
          />

          Select service: 
            <Autocomplete
              size="small"
              value={service}
              onChange={(event, newValue) => {
              setService(newValue);
              }}
              inputValue={serviceInputValue}
              onInputChange={(event, newInputValue) => {
              setServiceInputValue(newInputValue);
              }}
              id="controllable-states-demo"
              options={servicesOptions}
              sx={{ width: 350 , margin : "1em"}}
              renderInput={(params) => <TextField {...params} label="service" />}
          />



        <h3>Connect to redis-cli</h3> 
        {service && host && env ?( 
          <div>
            <ListItem divider={true}>
            1. Exec into the pod -
            <CopyToClipboardButton text={`${redisConnection}`} />
            </ListItem>
            <ListItem divider={true}>
            2. Connect to the redis instance - 
            <CopyToClipboardButton text={`redis-cli -h ${host} -p ${port} -n ${db}`}/>
            </ListItem>
          </div>):(
            <div style={{color: "#EF476F"}}>
            Select a env and service to get the redis cli commands
            </div>
          )
        }

</div>
      <div className="box" style={{"background": "white" , "display" : "block" , "height": "max-content" , "padding-left": "2em" , "padding-top": "2em" , "font-size": "medium" , "margin-top": "2em"}}>
        <h3> redis-cli cheatsheet </h3>
        <div style={{color: "#EF476F"}}>
        Warning: Avoid Using KEYS Command in Production
        Using the KEYS command in Redis can block the server and degrade performance, especially with large datasets. It performs a full scan of the keyspace, which can cause high memory usage and impact other operations.
        </div>
        <ListItem divider={true}>
        1. Get all keys -
        <CopyToClipboardButton text={`keys *`}/>
        </ListItem>
        <ListItem divider={true}>
        2. Get value of a key -
        <CopyToClipboardButton text={`get key_name_1`}/>
        </ListItem>
        <ListItem divider={true}>
        3. Set value of a key -
        <CopyToClipboardButton text={`set key_name_1 value_name_1`}/>
        </ListItem>
        <ListItem divider={true}>
        4. Delete a key -
        <CopyToClipboardButton text={`del key_name_1`}/>
        </ListItem>
        <ListItem divider={true}>
        5. Get all keys with pattern -
        <CopyToClipboardButton text={`keys *pattern*`}/>
        </ListItem>
        <ListItem divider={true}>
       6. Delete multiple keys - 
       <CopyToClipboardButton text={`DEL key_name_1 key_name_2 key_name_3`}/>
       </ListItem>
        <ListItem divider={true}>
          7. To get the Time-To-Live (TTL) of a key:
          <CopyToClipboardButton text={`TTL key_name_1`}/>
        </ListItem>
        <ListItem divider={true}>
          8. To rename a key:
          <CopyToClipboardButton text={`RENAME key new_key`}/>
        </ListItem>
      </div>

    </div>
  )
}